import { render, staticRenderFns } from "./BookmarkPost.vue?vue&type=template&id=6cfb2174&scoped=true"
import script from "./BookmarkPost.vue?vue&type=script&lang=js"
export * from "./BookmarkPost.vue?vue&type=script&lang=js"
import style0 from "./BookmarkPost.vue?vue&type=style&index=0&id=6cfb2174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfb2174",
  null
  
)

export default component.exports